import { render, staticRenderFns } from "./nuevoOficioGenerado.vue?vue&type=template&id=d0a09862"
import script from "./nuevoOficioGenerado.vue?vue&type=script&lang=js"
export * from "./nuevoOficioGenerado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports